var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderRight'),_c('Fullscreen'),_c('Lang',{attrs:{"type":"bottom-end"}}),_c('HeaderUser')],1)}
var staticRenderFns = []

export { render, staticRenderFns }